<!-- 定时管理时间设置 -->
<template>
     <el-form label-width="100px" :model="timeForm" :rules="rules" ref="timeForm" class="demo-form-inline setting-time">
        <el-form-item label="">
            <el-switch
                style="display: block"
                v-model="timeForm.value4"
                active-color="#13ce66"
                inactive-color="#ff4949"
                inactive-text="按星期管理"
                active-text="按日期管理"
                >
            </el-switch>
        </el-form-item>
        <el-form-item v-if="timeForm.value4" key="dates" label="定时日期" prop="dates">
            <el-date-picker
                style="width:100%;"
                type="dates"
                v-model="timeForm.dates"
                clearable
                value-format="yyyy-MM-dd"
                placeholder="选择一个或多个日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item v-else key="check" label="星期设置" prop="ckeckList">
            <el-checkbox-group v-model="timeForm.ckeckList">
                <el-checkbox label="1">星期一</el-checkbox>
                <el-checkbox label="2">星期二</el-checkbox>
                <el-checkbox label="3">星期三</el-checkbox>
                <el-checkbox label="4">星期四</el-checkbox>
                <br>
                <el-checkbox label="5">星期五</el-checkbox>
                <el-checkbox label="6">星期六</el-checkbox>
                <el-checkbox label="7">星期日</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="定时时间" prop="time">
            <el-time-picker
                style="width:100%;"
                v-model="timeForm.time"
                @change="changeInput()"
                clearable
                format="HH:mm"
                value-format="HH:mm"
                placeholder="请选择时间">
            </el-time-picker>
        </el-form-item>
        <el-form-item label="定时时间">
                   <el-input v-model="timeForm.times" placeholder="请输入时间"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name:  'CmpSettingTime',
    props: ["index", "parentData"],
    data() {
        return {
            timeForm: {
                value4: true,
                dates: [],
                ckeckList: [],
                time: '',
                times:'',
            },
            rules: {
                dates: [{ required: true, message: '请选择日期', trigger: 'change' }],
                time: [{ required: true, message: '请选择时间', trigger: 'change' }],
                ckeckList: [{ type: 'array', required: true, message: '请至少选择一天', trigger: 'change' }],
            }
        };
    },
    computed: {
        ...mapGetters(['settingTime'])
    },
    watch: {
        index(newVal, oldVal) {
            if(newVal == 3 && oldVal == 2) {
                // 保存
                this.next()
            }
        },
        parentData(newVal) {
            this.timeForm = Object.assign(this.timeForm, newVal) 
            this.timeForm.times = this.timeForm.time
        }
    },
    created() {
        this.timeForm = Object.assign(this.timeForm, this.parentData)
       
    },
    methods: {
        fmtData(data) {
            let obj = {}
            if(data.value4) {
                obj.type = "day"
                obj.data = [];
                data.dates.map(v=>{
                    obj.data.push({value: v})
                })
            }else{
                obj.type = "week"
                obj.data = [];
                data.ckeckList.map(v=>{
                    obj.data.push({value: v})
                })
            }
            obj.time = data.times
            return obj
        },
        next() {
            this.$refs["timeForm"].validate((valid) => {
                if (valid) {
                    let data = this.fmtData(this.timeForm);
                    this.$store.dispatch("settingTime", data)
					// this.$emit("getastate", true);
                    this.$emit("next", true);
					
                } else {
					// this.$emit("getastate", false);
                    this.$emit("next", false);
                    return false;
                }
            });
        },
        changeInput(){
            if (this.timeForm.time!=""){
                if(this.timeForm.time!="")
                {
                    if(this.timeForm.times.indexOf(this.timeForm.time)==-1)
                    {
                        if(this.timeForm.times!="")
                        {
                            var str =this.timeForm.times.substr(this.timeForm.times.length -1, this.timeForm.times.length);
                            if (str == ";")
                            {
                                this.timeForm.times = this.timeForm.times+this.timeForm.time;
                            }
                            else
                            {
                                this.timeForm.times = this.timeForm.times+";"+this.timeForm.time;
                            }
                        }
                        else
                        {
                            this.timeForm.times = this.timeForm.time;
                        }
                    }
                }
                // var timeRegex="([0-1]?[0-9]|2[0-3])-([0-5][0-9])";
                // var r=timeRegex.test(this.timeForm.time); 
                // if(r){
                //     if(this.timeForm.times.search(this.timeForm.time)==-1)
                //     {
                //         if(this.timeForm.times!="")
                //         {
                //        this.timeForm.times = this.timeForm.times+";"+this.timeForm.time;
                //         }
                //         else
                //         {
                //             this.timeForm.times = this.timeForm.time;
                //         }
                //     }
                // }
            }
        }
    }
}

</script>
<style lang='less' scoped>

</style>